import { cloneDeep } from 'lodash'
export default class AbstractFilter {
  /**
   * Create new filter
   *
   * @param {String} key
   * @param {String} label
   * @param {String} property
   * @param {String} [value]
   */
  constructor (key, label, property, value) {
    this.key = key
    this.label = label
    this.property = property

    this._value = value || null
    this._temporaryValue = value || null
  }

  /**
   * Get the applied value of this filter
   *
   * @return {String}
   */
  get value () {
    return this._value
  }

  /**
   * Set the value of this filter
   *
   * @param {string} value
   */
  set value (value) {
    this._value = value
    this._temporaryValue = value
  }

  /**
   * Get display value of this filter
   *
   * @return {String}
   */
  get displayValue () {
    return this._value
  }

  /**
   * Copy values from temporary value to value
   */
  apply () {
    this._value = this._temporaryValue
  }

  /**
   * Does this filter have a value?
   *
   * @return {boolean}
   */
  hasValue () {
    return this.value !== null && typeof this.value !== 'undefined'
  }

  /**
   * Get value of this filter as string
   *
   * @return {String}
   */
  toString () {
    return `${this.value}`
  }

  /**
   * Reset filter
   */
  reset () {
    this._value = null
    this._temporaryValue = null
  }

  /**
   * Cancel filter
   */
  cancel () {
    this._temporaryValue = this._value ? cloneDeep(this._value) : null
  }
}
